import React, { useState } from 'react';
import { Box, Typography, Grid, Paper, Divider } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PropTypes from 'prop-types';

const payOptions = [
    {
        label: '카드',
        icon: <CreditCardIcon sx={{ fontSize: 32 }} color="primary" />,
        value: '카드',
    },
    {
        label: '무통장입금',
        icon: <AccountBalanceIcon sx={{ fontSize: 32 }} color="action" />,
        value: '가상계좌',
    },
    {
        label: '계좌이체',
        icon: <SwapHorizIcon sx={{ fontSize: 32 }} color="success" />,
        value: '계좌이체',
    },
];

export default function PaymentMethods({ onSelect }) {
    const [selected, setSelected] = useState(payOptions[0].value);

    return (
        <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto', mt: 2 }}>
            {/* 큰 제목과 밑줄 */}
            <Typography variant="h6" fontWeight={700} gutterBottom>
                결제수단
            </Typography>
            <Divider sx={{ mb: 3 }} />

            {/* 결제수단 선택 버튼 */}
            <Grid container spacing={1}>
                {payOptions.map((opt) => (
                    <Grid item xs={4} key={opt.value}>
                        <Paper
                            elevation={0}
                            sx={{
                                minWidth: 100,
                                width: '100%',
                                height: 90,
                                border: '2px solid',
                                borderColor: selected === opt.value ? '#1976d2' : '#e0e0e0',
                                borderRadius: 1.5,
                                bgcolor: selected === opt.value ? '#f5faff' : '#fff',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                boxShadow: 'none',
                                transition: '0.15s',
                                fontSize: '1.05rem',
                                fontWeight: 500,
                                userSelect: 'none',
                            }}
                            onClick={() => {
                                setSelected(opt.value);
                                onSelect && onSelect(opt.value);
                            }}
                        >
                            <Box mb={0.5}>{opt.icon}</Box>
                            <Typography
                                fontSize={17}
                                fontWeight={selected === opt.value ? 600 : 400}
                                color={selected === opt.value ? 'primary.main' : 'text.primary'}
                            >
                                {opt.label}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

PaymentMethods.propTypes = {
    onSelect: PropTypes.func,
};
